import { useFeatureFlagsReady } from '@newfront-insurance/admin-ui';
import { useEffect } from 'react';

import { useNovaNavigation } from './nova-navigation-context';
import { useCanViewNovaAnalytics } from '../hooks/use-can-view-nova-analytics';

export function NovaNavigationCanonicalizer() {
  const { view, actions } = useNovaNavigation();
  const ready = useFeatureFlagsReady();
  const analyticsEnabled = useCanViewNovaAnalytics();
  useEffect(() => {
    if (!ready) return;
    if (view.kind === 'settings' && view.section === 'analytics' && !analyticsEnabled) {
      actions.canonicalize({ kind: 'settings', section: 'general' });
    }
  }, [actions, analyticsEnabled, ready, view]);
  return null;
}
